import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router/index'
const app = createApp(App)
import ElementPlus from 'element-plus'
import api from './axios'
import '../src/assets/fonts.scss'
import dayjs from 'dayjs'


app.use(ElementPlus)
app.provide('$api', api)
app.provide('dayjs', dayjs)
import 'element-plus/dist/index.css'
import VueI18n from '@/locales/i18n';
app.use(VueI18n);
app.use(router)
app.mount('#app')


